import type { ReactNode } from "react";
import { useAuth } from "@utils/firebaseAuth/auth";

export function AuthBoundary({ children }: { children: ReactNode }) {
  useAuth();
  return children;
}
